import { render, staticRenderFns } from "./b2b-flex.vue?vue&type=template&id=1fc49718&functional=true"
import script from "./b2b-flex.vue?vue&type=script&lang=js"
export * from "./b2b-flex.vue?vue&type=script&lang=js"
import style0 from "./b2b-flex.vue?vue&type=style&index=0&id=1fc49718&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports